/* src/app/modules/accounting/reports/report-working-capital/report-working-capital.component.css */
:host {
  --wc-brand: #e3fd64;
  --wc-brand-d: #4d7a00;
  --wc-text: #1a1d23;
  --wc-muted: #6b7280;
  --wc-border: #e5e7eb;
  --wc-surface: #ffffff;
  --wc-radius: 10px;
  --wc-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.wc-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.wc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.wc-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.wc-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.wc-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.wc-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--wc-text);
  line-height: 1.2;
}
.wc-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--wc-muted);
}
.wc-toggle-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--wc-surface);
  border: 1px solid var(--wc-border);
  border-radius: var(--wc-radius);
  box-shadow: var(--wc-shadow);
  width: fit-content;
}
.wc-toggle-card mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--wc-brand);
}
.wc-toggle-label {
  font-size: 13.5px;
  color: var(--wc-text);
  font-weight: 500;
}
.wc-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.wc-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.wc-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--wc-brand);
}
.wc-loading__dots {
  display: flex;
  gap: 8px;
}
.wc-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--wc-brand);
  opacity: 0.3;
  animation: wc-pulse 1.2s ease-in-out infinite;
}
.wc-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.wc-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes wc-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.wc-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--wc-muted);
}
.wc-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
@media (max-width: 700px) {
  .wc-kpi-grid {
    grid-template-columns: 1fr;
  }
}
.wc-kpi {
  background: var(--wc-surface);
  border: 1px solid var(--wc-border);
  border-radius: var(--wc-radius);
  box-shadow: var(--wc-shadow);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  overflow: hidden;
}
.wc-kpi::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--wc-kpi-accent, var(--wc-border));
}
.wc-kpi--blue {
  --wc-kpi-accent: #3b82f6;
}
.wc-kpi--amber {
  --wc-kpi-accent: #f59e0b;
}
.wc-kpi--result {
  --wc-kpi-accent: var(--wc-kpi-result-color, #6b7280);
}
.wc-kpi__icon-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.wc-kpi__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--wc-kpi-icon-bg, rgba(227, 253, 100, 0.1));
  flex-shrink: 0;
}
.wc-kpi__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--wc-kpi-icon-color, var(--wc-brand));
}
.wc-kpi--blue .wc-kpi__icon {
  background: rgba(59, 130, 246, 0.1);
}
.wc-kpi--blue .wc-kpi__icon mat-icon {
  color: #3b82f6;
}
.wc-kpi--amber .wc-kpi__icon {
  background: rgba(245, 158, 11, 0.1);
}
.wc-kpi--amber .wc-kpi__icon mat-icon {
  color: #f59e0b;
}
.wc-kpi__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--wc-muted);
}
.wc-kpi__value {
  font-size: 26px;
  font-weight: 700;
  color: var(--wc-text);
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}
.wc-kpi--result .wc-kpi__value {
  color: var(--wc-kpi-result-color, var(--wc-text));
}
.wc-kpi__pct {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  width: fit-content;
}
.wc-kpi__pct--pos {
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}
.wc-kpi__pct--neg {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}
.wc-kpi__year {
  font-size: 12px;
  color: var(--wc-muted);
  margin-top: auto;
}
/*# sourceMappingURL=report-working-capital.component.css.map */
